/** Hook for rebalancing task order keys and materialized paths among siblings. */
import { useCallback } from 'react';
import { executeRebalance } from '@/features/tasks/utils/mutations/taskRebalanceUtils';

export const useTaskRebalance = () => {
  const rebalanceOrderKeys = useCallback(async (taskId, tasks) => {
    return executeRebalance(taskId, tasks);
  }, []);

  return { rebalanceOrderKeys };
};
